<template>
    <div class="topcode-wechat-prospect-item" @click="$router.push('/prospect/detail/'+ prospect.id)">
        <div class="top">
            <div :class="'flex-center-y state  prospect-state-'+prospect.state">{{prospectStateDICT}}</div>
            <div class="flex-center-y time ">{{prospect.createdTime}}</div>
        </div>
        <div class="body">
            <div class="content">
                <div class="row"><label>勘察位置</label> <span>{{prospect.position}}</span></div>
                <div class="row"><label>所属单位</label> <span>{{prospect.unitName}}</span></div>
                <div class="row"><label>所属模板</label> <span>{{prospect.templateName}}</span></div>
            </div>
        </div>
        <div class="task-device-list">
            <TaskDeviceShow v-for="item in taskDeviceList" :key="item.id" :taskDevice="item"/>
        </div>
    </div>
</template>

<script>
    import * as DICT from "@/utils/dict"
    import TaskDeviceShow from "./TaskDeviceShow"

    export default {
        components: {TaskDeviceShow},
        props: {
            prospect: {type: Object, required: true}
        },
        data() {
            return {};
        },
        computed: {
            prospectStateDICT() {
                return DICT.getValue('PROSPECT_TASK_STATE', this.prospect.state)
            },
            taskDeviceList() {
                const {taskDeviceList} = this.prospect
                 return taskDeviceList ? taskDeviceList : []
            }
        },
        created() {
        },
        mounted() {

        },
        methods: {},
        watch: {}
    };
</script>

<style lang="less" scoped>
    .topcode-wechat-prospect-item {
        width: 100%;
        /*height: 225px;*/
        padding-bottom: 3px;
        margin-bottom: 8px;
        border-radius: 8px;
        border: 1px #cccccc solid;
        /*background: #51c332;*/

        & > .top {
            color: #fff;
            display: flex;
            height: 28px;
            border-radius: 8px 8px 0px 0px;
            background: #7e7e7e;
            & > .state {
                height: 100%;
                width: 60px;
                border-radius: 8px 0px 0px 0px;
                justify-content: center;
            }
            & > .time {
                height: 100%;
                width: calc(100% - 70px);
                justify-content: flex-end;
            }
        }
        & > .body {
            display: flex;
            & > .right {
                width: 25px;
                color: #1890ff;
                font-size: 20px;
                font-weight: 500;
            }
            & > .content {
                padding: 8px;
                width: 100%;
                & > .center {
                    padding: 5px;
                    display: flex;
                    /*background: #5cd8bc;*/
                    & > img {
                        width: 60px;
                        height: 60px;
                        background: #cccccc;
                        border-radius: 8px;
                    }
                    & > .name {
                        padding-left: 20px;
                        height: 100%;
                        display: flex;
                        /*background: #7e7e7e;*/
                        flex-direction: column;

                        & > div {
                            line-height: 1.5;

                        }
                    }
                }
                & > .row {
                    display: flex;
                    line-height: 1.5;
                    /*align-items: center;*/
                    & > label {
                        width: 75px;
                        flex-shrink: 0;
                        &::after {
                            margin-left: 2px;
                            content: '：';
                        }
                    }
                    & > span {
                    }
                }
            }
        }
    }
</style>
